export default {"src":"/_next/static/media/box-frequency.8008cf00.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};